import { Box } from "@mui/material";
import { EditorToolbar, EditorV2 } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormCommentsProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormComments = ({ control }: IModalActionFormCommentsProps) => {
  return (
    <Controller
      control={control}
      name="comments"
      render={({ field: { value, onChange, onBlur } }) => (
        <Box
          sx={{
            height: 210,
          }}
        >
          <EditorV2
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            init={{
              toolbar: [EditorToolbar.EDITORV2],
              max_height: 210,
            }}
          />
        </Box>
      )}
    />
  );
};
